import { useMutation, useQueryClient } from 'react-query';
import { API } from 'api';
import { getLatestQuery } from 'common';
import { toastPush } from 'modules';
import { useDispatch } from 'react-redux';

export interface IAddEmployerReportData {
  payload: {
    eid: string;
    fileName: string;
    data: string;
    type: string;
    withdrawalCycleId: string;
  };
}

const addEmployerReportData = (payload: IAddEmployerReportData['payload']) => {
  const formData = new FormData();
  formData.append('data', payload.data);
  formData.append('eid', payload.eid);
  formData.append('type', payload.type);
  formData.append('withdrawalCycleId', payload.withdrawalCycleId);

  return API.post()('/api/admin/financeFiles/employerReport/upload', formData, {
    'Content-Type': 'multipart/form-data',
  });
};

export const useAddEmployerReportData = () => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();
  const key = 'employerReports';
  const queryArr = queryClient.getQueriesData(key);
  const res = getLatestQuery(queryArr, queryClient);

  return useMutation(addEmployerReportData, {
    onSuccess: () => {
      dispatch(
        toastPush({
          code: 200,
          type: 'success',
          title: 'SUCCESS',
          body: 'toastPush.createdSucessful',
        })
      );
      return queryClient.invalidateQueries(key, res.queryParams);
    },
  });
};
